import React from "react";

const Right = () => {
  return (
    <div>
      <div className="end">
        <div className="flex flex-row items-center">
          <div className="mr-2">
            <div>
              <div>
                <div className="end-box">
                  <button>
                    <div
                      style={{ width: "24px", height: "23px", fill: "#c3c3c3" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        style={{
                          pointerEvents: "none",
                          display: "block",
                          width: "100%",
                          height: "100%",
                        }}
                        viewBox="0 0 24 24"
                        width="24"
                        focusable="false"
                      >
                        <path d="M14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2zm3-7H3v12h14v-6.39l4 1.83V8.56l-4 1.83V6m1-1v3.83L22 7v8l-4-1.83V19H2V5h16z"></path>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mr-2">
            <div>
              <div>
                <div className="end-box">
                  <button>
                    <div
                      style={{ width: "24px", height: "20px", fill: "#c3c3c3" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enableBackground="new 0 0 24 24"
                        height="20"
                        viewBox="0 0 24 24"
                        width="24"
                        focusable="false"
                        style={{
                          pointerEvents: "none",
                          display: "block",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <path d="M10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm10-2.65V19H4v-1.65l2-1.88v-5.15C6 7.4 7.56 5.1 10 4.34v-.38c0-1.42 1.49-2.5 2.99-1.76.65.32 1.01 1.03 1.01 1.76v.39c2.44.75 4 3.06 4 5.98v5.15l2 1.87zm-1 .42-2-1.88v-5.47c0-2.47-1.19-4.36-3.13-5.1-1.26-.53-2.64-.5-3.84.03C8.15 6.11 7 7.99 7 10.42v5.47l-2 1.88V18h14v-.23z"></path>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mr-2">
            <div>
              <div>
                <div className="end-box">
                  <button className="items-center justify-center">
                    <div
                      className="id"
                      style={{ width: "100%", height: "100%", fill: "#c3c3c3" }}
                    >
                      <img
                        id="img"
                        draggable="false"
                        className="style-scope yt-img-shadow"
                        alt="아바타 이미지"
                        height="32"
                        width="32"
                        src="https://yt3.googleusercontent.com/ytc/APkrFKaUAGg1uQnpiLKIQlq9iYUCDWZ_gEXWz4zTDRZQ_ROaoj-XHeNE7ojO1XsbCYq_=s88-c-k-c0x00ffffff-no-rj"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Right;
